module.exports = __webpack_public_path__ + "img/carlights.cdaad5bc.jpg";